export default "__VITE_ASSET__8493ebb3__"